import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { AuthRoutingModule } from './auth-routing.module';
import { TranslateModule } from '@ngx-translate/core';
import { ReactiveFormsModule, FormsModule } from '@angular/forms';
import { SharedModule } from '../shared/shared.module';
import { PlainToolbarModule } from '../plain-toolbar/plain-toolbar.module';
import { PlainFooterModule } from '../plain-footer/plain-footer.module';

import { MatInputModule } from '@angular/material/input';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatIconModule } from '@angular/material/icon';

import { AuthSigninComponent } from './auth-signin/auth-signin.component';
import { AuthSignupComponent } from './auth-signup/auth-signup.component';
import { AuthSigninFormComponent } from './auth-signin-form/auth-signin-form.component';
import { AuthSignupFormComponent } from './auth-signup-form/auth-signup-form.component';

@NgModule({
  declarations: [AuthSigninComponent, AuthSignupComponent, AuthSigninFormComponent, AuthSignupFormComponent],
  imports: [
    CommonModule,
    AuthRoutingModule,
    TranslateModule,
    ReactiveFormsModule,
    FormsModule,
    SharedModule,
    PlainToolbarModule,
    PlainFooterModule,
    MatInputModule,
    MatFormFieldModule,
    MatIconModule,
  ],
})
export class AuthModule {}
